import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Dropdown } from 'app/components';
import VenueModal from './venueForm';
import { createVenue, getVenueList } from './api';
import { ADD_VENUE_OPTION } from './constants';

const VenueDetails = ({ eventData, onChange }) => {
  const [isAddVenueOpen, setIsAddVenueOpen] = useState(false);

  const { venueList, cityList } = useSelector((state) => state.adminEventCreate);

  const handleDropdownChange = (value) => {
    if (value === 'add-venue') {
      setIsAddVenueOpen(true);
    } else {
      onChange({ ...eventData, venueID: value });
    }
  };

  const closeModal = () => setIsAddVenueOpen(false);

  const onAddVenue = (venue) => {
    createVenue(venue, (data) => {
      getVenueList();
      handleDropdownChange(data?._id);
      closeModal();
    });
  };

  return (
    <>
      <div className="event-details-form flex flex-col gap-10">
        <Dropdown
          options={ADD_VENUE_OPTION.concat(venueList || [])}
          value={eventData?.venueID}
          onChange={(value) => handleDropdownChange(value)}
          hasSearch={true}
          label="Select Venue"
          placeholder="Select Venue"
        />
        {isAddVenueOpen && (
          <VenueModal
            venueDetails={{}}
            cities={cityList}
            isModalOpen={isAddVenueOpen}
            onClose={closeModal}
            onSave={onAddVenue}
          />)}
      </div>
    </>
  );
};

export default VenueDetails;